import PolicyTerms from './PolicyTerms';

export default PolicyTerms;
